import { citiesCache } from "@/misc/httpCache";
import { get } from "./";
import { API_URL } from "@/misc/constants";
import { tInternalCity } from "@/types";

const base = API_URL + "/city";
const findBySlug = (slug: string) => {
  return get<tInternalCity>(`${base}/slug/${slug}`, { cache: citiesCache });
};
const getHighlighted = async () => {
  const { data } = await get<tInternalCity[]>(`${base}/searchable`, {
    cache: citiesCache,
  });
  return data;
};

export const CitiesAPI = {
  findBySlug,
  getHighlighted,
};
